import { FC, useEffect } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { setCookie } from '@lhb/cache';
import { dingTalkOauthLogin } from '@/common/api/dd';
// import { DD_SUITE_KEY } from './ts-config';
import { Spin } from 'antd';
import * as dd from 'dingtalk-jsapi';
import styles from './entry.module.less';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { recursiveDecodeURIComponent } from '@/common/utils/ways';

const Exemption: FC<any> = () => {
  const { corpId, clientId, originUrl } = urlParams(location.search);

  useEffect(() => {
    const platform = dd.env.platform;
    if (platform === 'pc') {
      methods.dingLogin();
    }
  }, []);


  const methods = useMethods({
    dingLogin: () => {
      dd.requestAuthCode({
        corpId,
        clientId,
        // clientId: DD_SUITE_KEY,
        onSuccess: (result) => {
          // console.log('result', result);
          const params = { code: result?.code, corpId };
          dingTalkOauthLogin(params).then((res) => {
            // 这里不需要判断是否属于多个企业	multiTenant，因为corpId指定了对应的租户，所以拿到的token就直接写入进行登录，不再需要切换租户了
            const { token, employeeId, tenantId } = res;
            tenantId && setCookie('tenantId', tenantId);
            employeeId && setCookie('employeeId', employeeId);
            token && setCookie('flow_token', token);
            // 刷新页面
            setTimeout(() => {
              if (originUrl) {
                const target = recursiveDecodeURIComponent(originUrl);
                window.location.replace(target || '/');
                return;
              }
              // window.location.href = '/';
              window.location.replace('/');
            }, 100);
          });
        },
        onFail: (err) => {
          // console.log('requestAuthCode fail: ' + JSON.stringify(err));
          V2Message.error(`钉钉免登错误：${JSON.stringify(err)}`);
        },
        complete: () => {
          // console.log('requestAuthCode complete: ' + JSON.stringify(res));
        }
      });
    }
  });

  return (
    <div className={styles.container}>
      <Spin size='large' tip='登录中...'/>
    </div>
  );
};

export default Exemption;
